module.exports = __webpack_public_path__ + "img/4.377f3ef1.jpg";